import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import JsonYamlConverter from '../../components/JsonYamlConverter';

const JsonYamlConvert: React.FC = () => (
  <ToolLayout
    title="JSON to YAML Converter - YAML to JSON | AllTools"
    description="Convert between JSON and YAML formats instantly. Free online format converter with validation."
    canonicalPath="/json-yaml-converter"
  >
    <JsonYamlConverter />
  </ToolLayout>
);

export default JsonYamlConvert;
